import React from 'react';
import NavbarItem from './NavbarItem';

function Navbar({ navItems }) {
  return (
    <ul className="main-menu nav">
      <NavbarItem navItems={navItems} />
    </ul>
  );
}

export default Navbar;
